var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0813 9.77721V9.77609C10.0194 9.78059 9.70051 9.79971 8.98894 9.79971C8.42082 9.79971 8.02088 9.78284 7.88026 9.77609V9.77777C5.69326 9.68159 4.06088 9.30077 4.06088 8.84515C4.06088 8.39009 5.69326 8.00927 7.88026 7.9114V9.39865C8.02313 9.40877 8.43263 9.43296 8.99851 9.43296C9.67745 9.43296 10.0178 9.40484 10.0813 9.39921V7.91252C12.2638 8.00984 13.8923 8.39065 13.8923 8.84515C13.8923 9.30077 12.2638 9.68046 10.0813 9.77721ZM10.0813 7.75784V6.42696H13.1267V4.39746H4.83488V6.42696H7.88026V7.75727C5.40526 7.8709 3.54395 8.3614 3.54395 8.94865C3.54395 9.5359 5.40526 10.0258 7.88026 10.14V14.4049H10.0813V10.1389C12.5524 10.0253 14.4092 9.53534 14.4092 8.94865C14.4092 8.36196 12.5524 7.87202 10.0813 7.75784Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdtIcon);
export default __webpack_public_path__ + "static/media/usdtIcon.a75d2d711dbdfff2860839c5c786c7da.svg";
export { ForwardRef as ReactComponent };